import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class FunctionsService {

  pipe = new DatePipe('en-US');

  constructor() { }


  removeFilter(arr,key) {
    delete arr[key];
    return arr;
  }

  filter(form: FormGroup, arr) {
    Object.keys(form.controls).forEach(key => {
      let val = form.controls[key].value;
      if (val != "" && val != null) {
        if (val.trim().length != 0) {
          if (arr.indexOf(val) === -1) {
            arr[key] = val;
          } 
        }
      } else if (val == "" && arr[key]) {
        delete arr[key];
      }
    });
    return arr;
  }

    /**
   * Loop range date
   * @param data 
   */
  loopRangeDate(data: any[],list?:any){
    var datesRange = [];
    let now = new Date(data[1]);
    for (var d = new Date(data[0]); d <= now; d.setDate(d.getDate() + 1)) {
      datesRange[this.pipe.transform(new Date(d),'yyyy-MM-dd')] = {
        id: 0,
        travel_auth_id:0,
        itinerary_date  : this.pipe.transform(new Date(d),'yyyy-MM-dd'),
        isTravel:false,
        total_transportation_cost : 0,
        accommodation_cost : 0,
        per_diem : 0,
        meal : 0,
        representation : 0,
        miscellaneous : 0,
        total_expense : 0,
        is_breakfast:0,
        is_lunch:0,
        is_dinner:0,
        bill_to: '',
        booked_by: '',
        itinerary_miscellaneous: [],
        travel_itinerary_liquidation:0,
        travel_itinerary_liquidation_list:[],
        travel_itinerary_reimbursement:0,
        travel_itinerary_reimbursement_list:[],
        travel_itinerary_details:[]
      };
    }
    list.forEach(element => {
      if (datesRange[element.itinerary_date]) {
        datesRange[element.itinerary_date].id = element.id;
        datesRange[element.itinerary_date].travel_auth_id = element.travel_authorization_id;
        datesRange[element.itinerary_date].itinerary_date = element.itinerary_date;
        datesRange[element.itinerary_date].total_transportation_cost = element.total_transportation_cost;
        datesRange[element.itinerary_date].accommodation_cost = element.accommodation_cost;
        datesRange[element.itinerary_date].per_diem = element.per_diem;
        datesRange[element.itinerary_date].meal = element.meal;
        datesRange[element.itinerary_date].total_expense = element.total_expense;
        datesRange[element.itinerary_date].is_breakfast = element.is_breakfast;
        datesRange[element.itinerary_date].is_lunch = element.is_lunch;
        datesRange[element.itinerary_date].is_dinner = element.is_dinner;
        datesRange[element.itinerary_date].bill_to = element.bill_to;
        datesRange[element.itinerary_date].booked_by = element.booked_by;
        datesRange[element.itinerary_date].itinerary_miscellaneous = element.itinerary_miscellaneous;

        datesRange[element.itinerary_date].booking_type = element.booking_type;
        datesRange[element.itinerary_date].booking_method = element.booking_method;
        datesRange[element.itinerary_date].accommodation_cost = element.accommodation_cost;

        element.itinerary_miscellaneous.forEach((el,i) => {          
          if (el.miscellaneous.name == "Representation") {
            datesRange[element.itinerary_date].representation = (el.amount == null)? 0  : el.amount;
          }
          if (el.miscellaneous.name == "Miscellaneous") {
            datesRange[element.itinerary_date].miscellaneous = (el.amount == null)? 0  : el.amount;
          }
        });

        if (element.travel_itinerary_liquidation) {
          datesRange[element.itinerary_date].travel_itinerary_liquidation = element.travel_itinerary_liquidation.total_actual_expense;
          datesRange[element.itinerary_date].travel_itinerary_liquidation_list = element.travel_itinerary_liquidation;
        }

        if (element.travel_itinerary_reimbursement) {
          datesRange[element.itinerary_date].travel_itinerary_reimbursement = element.travel_itinerary_reimbursement.total_actual_expense;
          datesRange[element.itinerary_date].travel_itinerary_reimbursement_list = element.travel_itinerary_reimbursement;
        }
      
        datesRange[element.itinerary_date].travel_itinerary_details = element.travel_itinerary_details;
        datesRange[element.itinerary_date].isTravel = true;
      }
    });
    return datesRange;
  }

  getDate(formatString = 'ymd-Hmms') {
    return this.pipe.transform(new Date(),formatString);
  }
  

}
